
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 35 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M34.622 3.586v15.567a3.588 3.588 0 01-3.586 3.585h-1.1c.185-.432.296-.915.296-1.434V5.737a3.588 3.588 0 00-3.585-3.586H17.67A3.592 3.592 0 0120.959 0h10.077a3.588 3.588 0 013.586 3.586z","fill":"#FFB30B"}}),_c('path',{attrs:{"d":"M32.136 4.847v15.567c0 .507-.112.99-.297 1.435A3.6 3.6 0 0128.549 24H3.587A3.588 3.588 0 010 20.414V9.608a3.588 3.588 0 013.586-3.586h8.136c1.434 0 2.72-.853 3.276-2.152.037-.074.062-.148.087-.222a3.59 3.59 0 013.375-2.374h10.09a3.588 3.588 0 013.585 3.586v-.013z","fill":"#FFD664"}}),_c('path',{attrs:{"d":"M23.828 1.261L10.709 23.987h-7.11a3.588 3.588 0 01-3.585-3.585V9.595a3.588 3.588 0 013.585-3.586h8.136a3.562 3.562 0 003.363-2.374 3.59 3.59 0 013.376-2.374h5.354z","fill":"#FFCD50"}})])
          )
        }
      }
    